/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserDevicePushTokensPostRequest
 */
export interface UserDevicePushTokensPostRequest {
    /**
     * The Expo push token from the device.
     * Format: ExponentPushToken[...]
     * This token is obtained from the Expo Notifications API on the mobile device.
     * 
     * @type {string}
     * @memberof UserDevicePushTokensPostRequest
     */
    expoPushToken: string;
    /**
     * The platform (ios or android)
     * @type {string}
     * @memberof UserDevicePushTokensPostRequest
     */
    platform: UserDevicePushTokensPostRequestPlatformEnum;
    /**
     * Optional device name for identification (e.g., "John's iPhone")
     * @type {string}
     * @memberof UserDevicePushTokensPostRequest
     */
    deviceName?: string;
}


/**
 * @export
 */
export const UserDevicePushTokensPostRequestPlatformEnum = {
    Ios: 'ios',
    Android: 'android'
} as const;
export type UserDevicePushTokensPostRequestPlatformEnum = typeof UserDevicePushTokensPostRequestPlatformEnum[keyof typeof UserDevicePushTokensPostRequestPlatformEnum];


/**
 * Check if a given object implements the UserDevicePushTokensPostRequest interface.
 */
export function instanceOfUserDevicePushTokensPostRequest(value: object): value is UserDevicePushTokensPostRequest {
    if (!('expoPushToken' in value) || value['expoPushToken'] === undefined) return false;
    if (!('platform' in value) || value['platform'] === undefined) return false;
    return true;
}

export function UserDevicePushTokensPostRequestFromJSON(json: any): UserDevicePushTokensPostRequest {
    return UserDevicePushTokensPostRequestFromJSONTyped(json, false);
}

export function UserDevicePushTokensPostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDevicePushTokensPostRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'expoPushToken': json['expo_push_token'],
        'platform': json['platform'],
        'deviceName': json['device_name'] == null ? undefined : json['device_name'],
    };
}

export function UserDevicePushTokensPostRequestToJSON(json: any): UserDevicePushTokensPostRequest {
    return UserDevicePushTokensPostRequestToJSONTyped(json, false);
}

export function UserDevicePushTokensPostRequestToJSONTyped(value?: UserDevicePushTokensPostRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expo_push_token': value['expoPushToken'],
        'platform': value['platform'],
        'device_name': value['deviceName'],
    };
}

